import styled from "styled-components";
import { typographyMixin } from "../../typography";

type DropdownMenuProps = {
  hidden?: boolean;
}

export const DropdownContainer = styled.div`
${typographyMixin}
position: relative;
display: inline-block;
`;

export const DropdownMenuContainer = styled.div`
position: absolute;
right: 0;
top: 2rem;

&.hidden {
  display: ${(p: DropdownMenuProps) => p.hidden ? 'none' : 'block'};
}

.menu {
  background-color: #FFF;
  border-radius: 0.2rem;
  border: 1px solid ${p => p.theme.primaryColor};
  border-left-color: rgba(${p => p.theme.muted}, 0.7);
  border-top-color: rgba(${p => p.theme.muted}, 0.7);
  border-right-color: darken(${p => p.theme.muted}, 10%);
  border-bottom-color: darken(${p => p.theme.muted}, 10%);
}
`;


export const StyledDropDownMenu = styled.div<DropdownMenuProps>`
  ${typographyMixin}

  position: relative;
  display: inline-block;

  .dd-menu {
    position: absolute;
    right: 0;
    top: 2rem;
    border-radius: 0.1rem;

    border: 1px solid black;

    &.hidden {
      display: none;
    }
  }
`;



// import styled from "styled-components";
// import { typographyMixin } from "../../typography";
// import { setThemeColor } from "../../setThemeColor";
// import { Theme } from "../../shared.types";
// import { DropdownMenuProps } from "./DropdownMenu.types";


// export const StyledDropDownMenu = styled.div<DropdownMenuProps>`
//   ${typographyMixin}

//   position: relative;
//   display: inline-block;

//   .dd-menu {
//     position: absolute;
//     right: 0;
//     top: 2rem;
//     border-radius: 0.1rem;

//     border: 1px solid black;

//     &.hidden {
//       display: none;
//     }
//   }
// `;
